module.exports = __webpack_public_path__ + "img/logo.14f3b55.svg";